import React from "react";
import { observer } from "mobx-react";
import { CustomersStore, Customer, SearchedCustomer } from "../stores";
import { Modal, Button, Row, Col, Form, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { wrapInput } from "../common/FormChangeWrapper";
import { formatShortDate } from "../common/Formatting";

interface IProps {
    customersStore: CustomersStore;
    isOpened: boolean;
    onHideHandler: () => void;
    source: string;
    onCustomerSelected: (customer: Customer) => void;
    openNewCustomerModal: () => void;
    title?:string;
    // savedCallback: (customer: Customer) => void;
}

interface IState {
    searchString: string;
    searchedCustomers: SearchedCustomer[];
    isSearched: boolean;

}

@observer
export class SelectCustomerModal extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            searchString: "",
            searchedCustomers: [],
            isSearched: false
        };
    }
    private formikSumbitEvent?: () => Promise<any> = undefined;

    componentDidUpdate(prevProps: IProps, prevState: IState) {
        if (this.props.isOpened === false && prevState.searchedCustomers !== undefined && prevState.searchedCustomers.length > 0)
            this.setState({
                searchedCustomers: [],
                isSearched: false
            });
    }

    onFormChange = (fieldName: string, value: string) => {
        const self = this as any;
        self.setState(() => ({
            [fieldName]: value
        }));

    }

    onSearchCustomers = () => {
        this.props.customersStore.searchCustomers(this.props.source, this.state.searchString, (customers: SearchedCustomer[]) => {
            this.setState({
                searchedCustomers: customers,
                isSearched: true
            })
        });
    }

    render() {
        return <Modal show={this.props.isOpened} size="xl" onHide={this.props.onHideHandler}>
            <Modal.Header closeButton>
                <Modal.Title>{this.props.title??"Выбор клиента"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col sm={12}>
                        <Form onSubmit={(e: any) => {
                            e.preventDefault();
                        }}>
                            <Form.Row>
                                <Col sm="9">
                                    <Form.Control placeholder="Введите телефон / имя / фамилию / Email"
                                        name="searchString"
                                        value={this.state.searchString}
                                        onChange={wrapInput(this.onFormChange)} />
                                </Col>
                                <Col sm="3">
                                    <Button type="submit" variant="primary" className="col-md-12" onClick={this.onSearchCustomers}>
                                        <FontAwesomeIcon icon="search" />{' '}Поиск
                                    </Button>
                                </Col>
                            </Form.Row>
                        </Form>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col sm={12}>
                        {this.state.isSearched ? <Table bordered striped className="table-xxs">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Фио</th>
                                    <th className="text-center">Регистрация <br />на сайте</th>
                                    <th className="text-center">Телефон</th>
                                    <th className="text-center">Email</th>
                                    <th className="text-center">Дата регистрации</th>
                                    <th className="text-center">Адрес</th>
                                    <th>Комментарий</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.searchedCustomers.length > 0 ? this.state.searchedCustomers.map((w, index) => {
                                    const name = w.markedFields.name || w.name;
                                    const fullName = w.markedFields.fullName || w.fullName;
                                    const address = w.markedFields.address || w.address;
                                    return <tr key={index}>
                                        <td className="text-center">{index + 1}</td>
                                        <td dangerouslySetInnerHTML={{ __html: `${name}<br /><small>${fullName}</small>` }}></td>
                                        {w.toSiteBinded ? <td className="text-center"><FontAwesomeIcon style={{ color: "green" }} icon="check" /></td> :
                                            <td className="text-center"><FontAwesomeIcon style={{ color: "red" }} icon="times" /></td>}
                                        <td className="text-center">{w.phone}</td>
                                        <td className="text-center">{w.email}</td>
                                        <td className="text-center">{w.createDate !== undefined ? formatShortDate(w.createDate) : ''}</td>
                                        <td className="text-center"><small dangerouslySetInnerHTML={{ __html: address }}></small></td>
                                        <td>{w.comment}</td>
                                        <td className="text-center"><Button size="sm" onClick={() => this.props.onCustomerSelected(w)}>Выбрать</Button></td>
                                    </tr>
                                }) : <tr>
                                        <td colSpan={9} className="text-center">
                                            <span>Ничего не найдено</span>
                                            {this.props.source !== "as" ? <a href="javascript:void(0)" onClick={this.props.openNewCustomerModal}>
                                                <br />
                                                <FontAwesomeIcon icon="plus" />{' '}Создать клиента
                                            </a> : []}
                                        </td>
                                    </tr>}

                            </tbody>
                        </Table> : []}
                    </Col>
                </Row>
            </Modal.Body>
        </Modal >
    }
}